exports = module.exports = require("../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapse-transition{transition:height .2s ease-in-out,padding-top .2s ease-in-out,padding-bottom .2s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?importLoaders=1!./~/_postcss-loader@2.1.6@postcss-loader/lib!./src/directive/collapse-transition/collapse-transition.css
// module id = 756
// module chunks = 9